import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = { class: "cardbody" }
const _hoisted_4 = { class: "flex flex-row-reverse items-center" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_10 = { class: "flex flex-col h-full" }
const _hoisted_11 = { class: "flex-1 overflow-auto" }
const _hoisted_12 = { class: "popup-business" }
const _hoisted_13 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_14 = { class: "formcontainer flex flex-col" }
const _hoisted_15 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_18 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "formcontainer mt-2 flex flex-col" }
const _hoisted_22 = { class: "w-full" }
const _hoisted_23 = ["error"]
const _hoisted_24 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_25 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_26 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "formcontainer flex flex-col" }
const _hoisted_30 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_31 = { class: "w-3/6" }
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_34 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "w-3/6 leftspacing" }
const _hoisted_37 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_38 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_39 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_40 = { key: 2 }
const _hoisted_41 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "title" }, "Threat", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.threatList.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.threatList.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _cache[13] || (_cache[13] = _createTextVNode(" Filters "))
            ], 2),
            (_ctx.pageType == false)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btnprimary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopup()))
                }, "Add"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _cache[32] || (_cache[32] = _createElementVNode("div", null, null, -1)),
    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "mt-3 text-xs" }, [
      _createElementVNode("div", null, " Risk management is the process of identifying, assessing and controlling financial, legal, strategic and security risks to an organization’s capital and earnings. These threats, or risks, could stem from a wide variety of sources, including financial uncertainty, legal liabilities, strategic management errors, accidents and natural disasters.To reduce risk, an organization needs to apply resources to minimize, monitor and control the impact of negative events while maximizing positive events. A consistent, systemic and integrated approach to risk management can help determine how best to identify, manage and mitigate significant risks. ")
    ], -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.threatList,
        headersData: _ctx.headers,
        openPopup: _ctx.handlePopUp,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "openPopup", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.isShow)
        ? (_openBlock(), _createBlock(_component_popup, { key: 0 }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Threat", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelBtn('close')))
                }, _cache[15] || (_cache[15] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Threat ID", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedThreat.threatId) = $event)),
                              placeholder: "Threat Id",
                              id: "id",
                              class: _normalizeClass(["inputboxstyling", {
                                        'is-invalid': (_ctx.v$.selectedThreat.threatId.$error||_ctx.checkThreatId||_ctx.displayErrorMessageOfThreatId)
                                    }]),
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.restrictCharacters1('threatId')))
                            }, null, 34), [
                              [
                                _vModelText,
                                _ctx.selectedThreat.threatId,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.selectedThreat.threatId.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (_ctx.v$.selectedThreat.threatId.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.displayErrorMessageOfThreatId == true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[17] || (_cache[17] = [
                                    _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                  ])))
                                : (_ctx.checkThreatId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[18] || (_cache[18] = [
                                      _createElementVNode("div", { class: "text-red-500 text-xs" }, "Threat Id already Exists", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "controllabel" }, "Threat", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling", {'is-invalid':(_ctx.v$.selectedThreat.threatEvent.$error || _ctx.isDuplicateCombination == true || _ctx.isDuplicateEvent == true)}]),
                            placeholder: "Threat",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedThreat.threatEvent) = $event)),
                            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetEventError && _ctx.resetEventError(...args))),
                            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.selectedThreat.threatEvent.$touch())),
                            error: (_ctx.v$.selectedThreat.threatEvent.$error|| _ctx.isDuplicateCombination == true || _ctx.isDuplicateEvent == true)
                          }, null, 42, _hoisted_23), [
                            [
                              _vModelText,
                              _ctx.selectedThreat.threatEvent,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.selectedThreat.threatEvent.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (_ctx.v$.selectedThreat.threatEvent.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Required"))
                                  : (_ctx.v$.selectedThreat.threatEvent.required && _ctx.v$.selectedThreat.threatEvent.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : (_ctx.isDuplicateEvent == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[20] || (_cache[20] = [
                                  _createElementVNode("div", { class: "text-red-500 text-xs" }, "Threat already exists", -1)
                                ])))
                              : (_ctx.isDuplicateCombination == true)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[21] || (_cache[21] = [
                                    _createElementVNode("div", { class: "text-red-500 text-xs" }, "Threat already exists", -1)
                                  ])))
                                : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "controllabel" }, "Threat Source", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.selectedThreat.threatSource,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedThreat.threatSource) = $event)),
                              suggestions: _ctx.searchThreatSourceList,
                              onComplete: _ctx.asyncthreatSourceDataFind,
                              onItemSelect: _ctx.selectedThreatSourceOption,
                              onInput: _ctx.resetSourceError,
                              forceSelection: "",
                              field: "label",
                              placeholder: "Threat Source",
                              class: _normalizeClass(["custom-multiselect userSelect w-full", {
                                        'p-invalid': _ctx.v$.selectedThreat.threatSource.$error||_ctx.isDuplicateSource||_ctx.isDuplicateCombination,
                                        'has-options': _ctx.searchThreatSourceList && _ctx.searchThreatSourceList.length > 0,
                                        'no-options': !_ctx.searchThreatSourceList.length && _ctx.searchValue !== '',
                                    }])
                            }, {
                              empty: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Source Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "onInput", "class"]),
                            (_ctx.v$.selectedThreat.threatSource.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  (_ctx.v$.selectedThreat.threatSource.required.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.isDuplicateSource)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[24] || (_cache[24] = [
                                  _createElementVNode("div", { class: "error-text text-xs" }, "Threat Source already exists", -1)
                                ])))
                              : (_ctx.isDuplicateCombination)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[25] || (_cache[25] = [
                                    _createElementVNode("div", { class: "text-red-500 text-xs" }, "Threat Source already exists", -1)
                                  ])))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", null, [
                              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "controllabel" }, "Threat Category", -1)),
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.selectedThreat.threatCategory,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedThreat.threatCategory) = $event)),
                                suggestions: _ctx.searchThreatCategoryList,
                                onComplete: _ctx.asyncthreatCategoryDataFind,
                                onItemSelect: _ctx.selectedOption,
                                onInput: _ctx.resetCategoryError,
                                forceSelection: "",
                                field: "label",
                                placeholder: "Threat Source",
                                class: _normalizeClass(["custom-multiselect userSelect w-full", {
                                            'p-invalid': _ctx.v$.selectedThreat.threatCategory.$error||_ctx.isDuplicateCategory||_ctx.isDuplicateCombination,
                                            'has-options': _ctx.searchThreatCategoryList && _ctx.searchThreatCategoryList.length > 0,
                                            'no-options': !_ctx.searchThreatCategoryList.length && _ctx.searchValue !== '',
                                        }])
                              }, {
                                empty: _withCtx(() => _cache[27] || (_cache[27] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Categories Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "suggestions", "onComplete", "onItemSelect", "onInput", "class"]),
                              (_ctx.v$.selectedThreat.threatCategory.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    (_ctx.v$.selectedThreat.threatCategory.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_ctx.isDuplicateCategory)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _cache[28] || (_cache[28] = [
                                      _createElementVNode("div", { class: "error-text text-xs" }, "Threat Category already exists", -1)
                                    ])))
                                  : (_ctx.isDuplicateCombination)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[29] || (_cache[29] = [
                                        _createElementVNode("div", { class: "text-red-500 text-xs" }, "Threat Category already exists", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      disabled: _ctx.clickOnButton,
                      class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancelBtn(_ctx.selectedThreat._id)))
                    }, "Reset", 10, _hoisted_42),
                    (!_ctx.selectedThreat._id)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addOrUpdatethreat(_ctx.selectedThreat))),
                          class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none')
                        }, "Save", 10, _hoisted_43))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          disabled: _ctx.clickOnButton,
                          class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addOrUpdatethreat()))
                        }, "Update", 10, _hoisted_44))
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}